import { FC } from 'react'
import { useField } from 'react-final-form'

import TextArea from '../molecules/TextArea'

type Props = {
  isConfirm: boolean
  label?: string
  required?: boolean
  placeholder?: string
}

const NAME = 'reason'

const ReasonField: FC<Props> = ({
  isConfirm,
  label = '応募理由',
  required = false,
  placeholder = 'この職種に応募したい理由やモチベーション、今後どのように活躍していきたいかを熱意を込めて書いてください。',
}) => {
  const {
    input: { value },
  } = useField(NAME)

  if (isConfirm && !value) return null

  return (
    <TextArea
      label={label}
      name={NAME}
      isConfirm={isConfirm}
      required={required}
      placeholder={placeholder}
    />
  )
}

ReasonField.displayName = 'reason'

export default ReasonField
